<script>
    import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
    import Loading from "../../common/loading.vue";
    import DialogHeader from "../../dialog/components/dialog-header.vue";
    import DialogBody from "../../dialog/components/dialog-body.vue";
    import DialogButton from "../../dialog/components/dialog-button.vue";
    import DialogBase from "../../dialog/components/dialog-base.vue";

    export default {
        name: 'admin-message-dialog',
        components: {DialogBase, DialogButton, DialogBody, DialogHeader, Loading, DialogActionbar},
        data() {
            return {
                t_cancel:           Lang.langGet("Cancel"),
                t_ok:               Lang.langGet("Ok"),
                t_ok_remember:      Lang.langGet("Ok and do not ask again"),
                t_system_message:   Lang.langGet('System Message'),

                modalName:          'show-admin-message-modal',
                messages:           {},
                message:            {},
                msg_index:          0,
                dismissing:         false,

                showDialog:         false
            }
        },
        computed: {
            htmlText() {
                const html = this.message.displayed_message;

                if (!html) return null;

                if (this.isValidHtml(html)) return html;

                return `<h1>${html}</h1>`
            }
        },
        methods: {
            isValidHtml(text) {
                return text.charAt(0) === '<';
            },
            confirm: function (proceed, remember=false) {
                if(this.dismissing) {
                    return;
                }
                this.dismissing = true;
                if (remember && proceed) {
                    axios.post('/system/system-messages/dismiss-message', {id: this.message.id}).then(() => {
                        this.dismissing = false;
                    });
                } else if(proceed) {
                    sessionStorage.setItem('admin-message-' + Laravel.activeUser + '-' + this.message.id, true);
                    axios.post('/system/system-messages/dismiss-message', {
                        id: this.message.id,
                        log_only: true,
                    }).then(() => {
                        this.dismissing = false;
                    });
                }
                this.update();
            },
            load: function() {
                axios.post('/system/system-messages/get-user-messages').then((response) => {
                    this.messages = Object.values(response.data.data).filter((message) => {
                        return sessionStorage.getItem('admin-message-' + Laravel.activeUser + '-' + message.id) === null;
                    });
                    if(this.messages.length > 0) {
                        this.message = this.messages[this.msg_index++];
                        if(this.message.id === 4) {
                            this.prepareDateTime();
                        }
                        this.$nextTick(() => {
                            this.showDialog = true;
                        });
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                });
            },
            prepareDateTime: function() {
                let date_time = new Date(this.message.message.datetime);
                const date = date_time.toLocaleDateString(Laravel.activeLocale, {
                    year:   "numeric",
                    month:  "2-digit",
                    day:    "2-digit",
                });
                const start = date_time.toLocaleTimeString(Laravel.activeLocale, {timeStyle: 'short'});

                const end = new Date(date_time.getTime() + 30 * 60000).toLocaleTimeString(Laravel.activeLocale, {timeStyle: 'short'});

                const string = '<h4>' + Lang.langGet("Server will be down on :date from :start to :end.", {
                    date: date,
                    start: start,
                    end: end
                });
                this.message.displayed_message = this.message.displayed_message + string;
            },
            update: function() {
                if(this.messages.length > this.msg_index) {
                    this.message = this.messages[this.msg_index++];
                    this.$forceUpdate();
                } else {
                    this.showDialog = false;
                }
            },
        },
        mounted() {
            this.load();
        }
    }
</script>

<template>
    <dialog-base
        persistent
        :maxWidth="980"
        @close="confirm(true)"
        :showDialog="showDialog"
    >
        <dialog-header
            persistent
            @close="confirm(true)"
            :title="t_system_message"
        />
        <dialog-body>
            <div class="text-center" v-html="htmlText"></div>
        </dialog-body>
        <dialog-actionbar
            noIcons
            :abortText="t_ok"
            :confirmText="t_ok_remember"
            @close="confirm(true)"
            @save="confirm(true, true)"
        />
    </dialog-base>
</template>
